import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

/**
 * Restricts a route to local accounts (Fyes_AdminUsers). Cloud gateway
 * customers are sent to their own landing page instead.
 *
 * The legacy site never showed them the file portal — usr/main_gw.php had a
 * Gateways link where usr/main.php had Files — so reaching it by URL is not
 * something we want to allow either. The backend enforces the same rule
 * (fyesLocalRequired).
 */
export const localAccountGuard: CanActivateFn = () => {
    const session = inject(SessionService);
    const router = inject(Router);

    if (!session.isLoggedIn()) {
        router.navigate(['/']);
        return false;
    }
    if (!session.isLocal()) {
        router.navigate(['/gateways']);
        return false;
    }
    return true;
};
